import { useLanguage } from "../contexts/LanguageContext";
import { t as siteT } from "../i18n/site";

// Convenience hook: const t = useT(); t("nav_empresas")
export const useT = () => {
  const { lang } = useLanguage();
  return (key) => siteT(key, lang);
};

export const useLang = () => useLanguage().lang;

export default useT;
